/**
 * en-GB messages added by Phase 3 task M4 (docs/PHASE-3-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const m4EnGB = {
    // Notification channel, buttons and local reminders (Companion foundation)
    'companion.p3.channel.urgent': 'Urgent alerts',
    'companion.p3.channel.urgent_description': 'Evacuations and lone-working check-ins. These can sound even when the phone is quiet, if you allow it.',
    'companion.p3.notif.action_im_safe': "I'm safe",
    'companion.p3.notif.action_i_am_ok': "I'm OK",
    'companion.p3.notif.lone_due_title': 'Lone working check-in',
    'companion.p3.notif.lone_due_body': 'Please tell us you are OK.',
    'companion.p3.notif.result_sent': 'Thanks, sent',
    'companion.p3.notif.result_queued': 'No connection. This will be sent when you are back online.',
    // Shared by the safety screens
    'companion.p3.error.not_a_marshal': 'You are not set up as a marshal for this site.',
    'companion.p3.error.no_connection': 'No connection. Your action is saved and will be sent when you are back online.',
    'companion.p3.rollcall.cached': 'Showing the list saved on this phone.',
    'companion.p3.rollcall.saved_at': 'List saved at {time}',
    // Phone tap (only when the build includes card emulation)
    'companion.p3.phone_tap.unavailable': 'Phone tap is not available in this version of the app.',
    // Alerts and location (what is sent, when)
    'companion.p3.panic.location_shared': 'When you send an alert, your location at that moment is shared with your contacts. It is never tracked at any other time.',
    'companion.p3.lone.checkin_location_shared': 'Your location at the moment you check in is shared with your contacts. It is never tracked at any other time.',
    'companion.p3.evac.location_shared': 'Your location at the moment you tap this button is shared with the people running the roll call. It is never tracked at any other time.',
    // Lone-working contacts (only where the group lets people edit their own)
    'companion.p3.lone.contacts_edit': 'Change my contacts',
    'companion.p3.lone.contacts_edit_note': 'Your organisation lets you keep your own contacts. They are told if you miss check-ins or send an alert.',
    'companion.p3.lone.contacts_name': 'Name',
    'companion.p3.lone.contacts_phone': 'Mobile number',
    'companion.p3.lone.contacts_email': 'Email address',
    'companion.p3.lone.contacts_add': 'Add a contact',
    'companion.p3.lone.contacts_remove': 'Remove {name}',
    'companion.p3.lone.contacts_save': 'Save contacts',
    'companion.p3.lone.contacts_cancel': 'Cancel',
    'companion.p3.lone.contacts_saved': 'Contacts saved.',
    'companion.p3.lone.contacts_failed': 'The contacts could not be saved. Please try again when you have signal.',
    'companion.p3.lone.contacts_err_name': 'Every contact needs a name.',
    'companion.p3.lone.contacts_err_reach': 'Every contact needs a mobile number or an email address.',
    'companion.p3.lone.contacts_err_invalid': 'Check the mobile number and email address. Numbers need the area or country code.',
    'companion.p3.lone.contacts_err_many': 'You can keep up to {max} contacts.',
    // Documents: a PDF or a photo
    'companion.p3.work.doc_upload_any': 'Upload a PDF or photo',
    'companion.p3.work.doc_form_help_any': 'Choose a PDF or a photo from your phone, or take a clear photo of the whole document. Dates are optional, written like 2027-01-31.',
    'companion.p3.work.doc_pick': 'Choose a PDF or photo',
    'companion.p3.work.doc_file_none': 'Nothing chosen yet.',
    'companion.p3.work.doc_file_ready': 'Ready to send: {name}',
    'companion.p3.work.doc_file_photo': 'Photo',
    'companion.p3.work.doc_picker_failed': 'That file could not be opened. Please try another.',
    'companion.p3.work.doc_err_type': 'Only PDF, JPEG or PNG files can be sent.',
    'companion.p3.work.doc_err_size': 'That file is too large. The most that can be sent is {mb} MB.',
};
//# sourceMappingURL=m4.js.map